import ScriptingEffect from './ScriptingEffect.js';
import {doc} from './documentation.js';
import {pipe} from './pipe.js';
import {
    switchOutput,
    execute,
    notes,
    steps,
    prob,
} from './lang.js';
import {poly} from './poly.js';

class PolyEffect extends ScriptingEffect {
    constructor(track) {
        super("Poly", track);
        this.newVar("outputs", 2, 1, 8, "Number of outputs to split notes among.");
        this.clear();
    }

    get documentation() {
        return [
            "Splits any polyphony chords among the outputs of this effect."
        ];
    }

    set numberOfOutputs(s) {
    }

    get numberOfOutputs() {
        if (this.outputsParameter) {
            let x = Math.floor(this.var("outputs")());
            return isNaN(x) ? 2 : x;
        } else {
            return 2;
        }
    }

    getVisualizedParameters() {
        return [this.outputsParameter];
    }

    isRealTime() {
        return false;
    }

    clear() {
        let outputs = [];
        for (let i=0; i < this.numberOfOutputs; i++) {
            outputs.push(switchOutput(i));
        }
        this.myScript = pipe(
            poly(... outputs));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track, ignoreId=true) {
        let fx = new PolyEffect(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}


export default PolyEffect;
